export enum ExperienceTypes {
  PRIVATE = 0,
  GROUP = 1,
  TOUR = 2,
  TICKET = 3,
  INDEPENDENT_WALK = 4,
  TRANSFER_SERVICE = 5,
}

// Содержит строковые типы опыта из API и истории просмотров.
export enum ExperienceStringTypes {
  EXCURSION = 'excursion',
  GROUP = 'group',
  PRIVATE = 'private',
  TICKET = 'ticket',
  TOUR = 'tour',
  INDEPENDENT_WALK = 'independent_walk',
  TRANSFER_SERVICE = 'transfer_service',
}

// Преобразует строковый тип опыта из API в числовой тип карточки.
export const stringToExperienceType = (
  value: 'group' | 'private' | 'ticket' | 'tour' | 'transfer_service' | 'independent_walk',
): ExperienceTypes => {
  switch (value) {
    case ExperienceStringTypes.GROUP:
      return ExperienceTypes.GROUP;
    case ExperienceStringTypes.PRIVATE:
      return ExperienceTypes.PRIVATE;
    case ExperienceStringTypes.TICKET:
      return ExperienceTypes.TICKET;
    case ExperienceStringTypes.TOUR:
      return ExperienceTypes.TOUR;
    case ExperienceStringTypes.TRANSFER_SERVICE:
      return ExperienceTypes.TRANSFER_SERVICE;
    case ExperienceStringTypes.INDEPENDENT_WALK:
      return ExperienceTypes.INDEPENDENT_WALK;
    default:
      throw new Error('unexpected experience type');
  }
};
